import React, { Component } from "react"
import DynamicTable from "@atlaskit/dynamic-table"
import Moment from "moment-timezone"

const TOGGL_ERROR_DAILY_LIMIT = "101"
const TOGGL_ERROR_BREAK_LIMIT = "102"
const TOGGL_ERROR_OVERLAP = "103"
const TOGGL_ERROR_INVALID_START_TIME = "104"
const TOGGL_ERROR_INVALID_STOP_TIME = "105"
const TOGGL_ERROR_WEEKEND = "106"
const TOGGL_ERROR_VACATION = "107"
const TOGGL_ERROR_HOLIDAY = "108"

const error_descriptions = new Map()
error_descriptions.set(TOGGL_ERROR_DAILY_LIMIT, "Tageslimit erreicht")
error_descriptions.set(TOGGL_ERROR_BREAK_LIMIT, "Zu lange Arbeit ohne Pause")
error_descriptions.set(TOGGL_ERROR_OVERLAP, "Überschneidung")
error_descriptions.set(
  TOGGL_ERROR_INVALID_START_TIME,
  "Beginn der Aufzeichnung ist ausserhalb der erlaubten Zeit"
)
error_descriptions.set(
  TOGGL_ERROR_INVALID_STOP_TIME,
  "Ende der Aufzeichnung ist ausserhalb der erlaubten Zeit"
)
error_descriptions.set(TOGGL_ERROR_WEEKEND, "Eintrag ist am Wochenende")
error_descriptions.set(TOGGL_ERROR_VACATION, "Eintrag ist im Urlaub")
error_descriptions.set(TOGGL_ERROR_HOLIDAY, "Eintrag ist an Feiertag")

var header = {
  cells: [
    {
      key: "0",
      className: "columnHeader",
      content: "Zeit",
      isSortable: true,
      width: 4
    },
    {
      key: "1",
      className: "columnHeader",
      content: "Projekt/Beschreibung",
      isSortable: true,
      width: 11
    },
    {
      key: "2",
      className: "columnHeader",
      content: "Art",
      isSortable: true,
      width: 19
    },
    {
      key: "3",
      className: "columnHeader",
      content: "Fehlercode",
      isSortable: true,
      width: 6
    }
  ]
}

class ErrorList extends Component {
  render() {
    const { errors } = this.props
    var rows = []
    errors.forEach(function(error) {
      var row = {}
      var error_moment = new Moment(error.time)

      if (error.time != null) {
        row.key = error.time
      } else {
        row.key = error.code
      }

      row.cells = []
      row.cells.push({
        style: { fontSize: "smaller" },
        content: error_moment.isValid() ? error_moment.format("HH:mm") : "-"
      })
      row.cells.push({
        style: { fontSize: "smaller" },
        content: error.entry_project ? error.entry_project : "-"
      })
      row.cells.push({
        style: { fontSize: "smaller" },
        content: error_descriptions.get(error.code)
      })
      row.cells.push({
        style: { fontSize: "smaller" },
        content: error.code
      })

      rows.push(row)
    })

    return (
      <div
        style={{
          border: "2px solid #d0d0d0",
          padding: "5px",
          marginBottom: "10px"
        }}
      >
        <DynamicTable
          caption=""
          head={header}
          rows={rows}
          loadingSpinnerSize="large"
          isLoading={false}
          isFixedSize
          defaultSortKey="0"
          defaultSortOrder="ASC"
        />
      </div>
    )
  }
}

export default ErrorList



// WEBPACK FOOTER //
// ./src/components/ErrorList.jsx